@charset "UTF-8";

/* src/app/system-utils/action-button-generic/action-button-generic.component.scss */
.content {
  display: flex;
  height: 100%;
  padding: 8px;
  font-family: var(--tem-font-family);
}
.card-data {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  background: var(--tem-surface);
  overflow: hidden;
}
.card-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  background: var(--tem-surface-2);
  border-bottom: 1px solid var(--tem-border);
}
.card-title {
  flex: 1;
  font-size: var(--tem-fs-lg, 16px);
  font-weight: 600;
  color: var(--tem-ink);
}
.search-field {
  max-width: 240px;
}
.progress-line {
  height: 3px;
  width: 100%;
  overflow: hidden;
  position: relative;
  background: transparent;
}
.progress-line-active {
  background: var(--tem-accent-soft);
}
.progress-line-active::after {
  content: "";
  position: absolute;
  height: 100%;
  width: 40%;
  background: var(--tem-accent);
  animation: progress-indeterminate 1.2s ease-in-out infinite;
}
@keyframes progress-indeterminate {
  0% {
    left: -40%;
  }
  100% {
    left: 100%;
  }
}
.card-content {
  height: 100%;
  display: flex;
  overflow: auto;
  flex-direction: column;
  padding: 8px 16px;
}
.header-line {
  display: grid;
  gap: 15px;
  width: 100%;
  margin: 0.5rem 0;
  overflow: hidden;
  padding-left: 5px;
  padding-right: 5px;
}
.header {
  font-size: var(--tem-fs-sm, 12px);
  font-weight: 600;
  color: var(--tem-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.variation-grid {
  width: 100%;
  height: 30vh;
  overflow: auto;
  position: relative;
  padding-right: 10px;
}
.lines {
  display: grid;
  gap: 15px;
  align-items: center;
  min-height: 40px;
  width: 100%;
  overflow: hidden;
  border-top: 1px solid var(--tem-border);
  padding-left: 5px;
  padding-right: 5px;
}
.lines:hover {
  background-color: var(--tem-accent-soft);
  cursor: pointer;
}
.cell {
  min-width: 0;
  display: flex;
  align-items: center;
}
.column-data {
  width: 100%;
}
.data-text {
  font-size: var(--tem-fs-sm, 12px);
  color: var(--tem-ink);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
}
.data-object {
  font-size: 70%;
  color: var(--tem-ink);
  word-break: break-all;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  height: 40px;
  overflow-x: hidden;
  overflow-y: auto;
}
.action-image-buttons {
  font-size: 80%;
  width: 100%;
  padding: 10px 16px;
  border-top: 1px solid var(--tem-border);
  background: var(--tem-surface-2);
}
.no-data {
  display: flex;
  height: 100%;
  align-items: center;
  flex-direction: column;
}
/*# sourceMappingURL=action-button-generic.component.css.map */
